module.exports = __webpack_public_path__ + "/bundle/asset/exam-3-5b3e2dc65737d681ee56c02c0768d93b.png";